import { getRankingBadgeProps } from './helpers';
import { RankingBadge } from './RankingBadge';
import { RankingBadgeParams } from './types';

export function RankingStatusBadge(params: RankingBadgeParams) {
	return <RankingBadge {...getRankingBadgeProps(params)} />;
}
